import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as g from '../../globals';

@Injectable({
  providedIn: 'root',
})
export class CrmService {
  constructor(private http: HttpClient) {}

  getFilterFields(criteria: number) {
    return this.http.get(
      `${
        g.apiBaseUrl
      }APICampaignWizard/GetFilterFields?criteria=${criteria}`
    );
  }

  loadData(queryId: number, currentObjectVal: string) {
    return this.http.get(
      `${
        g.apiBaseUrl
      }APICampaignWizard/executequery?id=${queryId}&currentObject=${currentObjectVal}`
    );
  }

  getTargetGroupCols() {
    return this.http.get(
      `${g.apiBaseUrl}APICampaignWizard/TargetGroupSection`
    );
  }

  loadFilter(filterId: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http.post(
      `${g.apiBaseUrl}APICampaignWizard/GetCampaignFilterDetails?code=${filterId}`,
      JSON.stringify(filterId),
      httpOptions
    );
  }

  deleteFilter(filterId: string) {
    return this.http.post(
      `${g.apiBaseUrl}APICampaignWizard/DeleteCampaignFilter?code=${filterId}`,
      JSON.stringify(filterId)
    );
  }

  applyFilter(filterObject: any) {
    return this.http.post(
      `${g.apiBaseUrl}APICampaignWizard/ApplyCampaignFilter?campaignFilter=${filterObject}`,
      JSON.stringify(filterObject)
    );
  }
}
